import React, { Component } from 'react';
import VARIANT from '../constant/variant';
import { withTheme } from '../../../../theme';
import R from '../../../../core-res/R';
import hoistStatics from 'hoist-non-react-statics';
export default function withThemedStyles(DRNButton) {
    const ThemedButtonComponent = class ThemedButton extends Component {
        constructor() {
            super(...arguments);
            this.getContainerStyle = () => {
                const { theme, variant } = this.props;
                const circularButtonRadius = 24;
                const buttonBgColorPrimary = {
                    active: theme.tintPrimary,
                    pressed: theme.tintPrimary,
                    disabled: theme.lightNeutral,
                };
                const buttonTextColorPrimary = {
                    active: R.color.uiLightPrimary,
                    pressed: R.color.uiLightPrimary,
                    disabled: R.color.uiLightSecondary,
                };
                const buttonBgColorMainCta = {
                    active: theme.accentPrimary,
                    pressed: theme.accentPrimary,
                    disabled: theme.lightNeutral,
                };
                const buttonTextColorMainCta = {
                    active: R.color.uiLightPrimary,
                    pressed: R.color.uiLightPrimary,
                    disabled: R.color.uiLightSecondary,
                };
                const buttonBgColorSecondary = {
                    active: theme.lightStain,
                    pressed: theme.lightStain,
                    disabled: theme.lightNeutral,
                };
                const buttonTextColorSecondary = {
                    active: theme.tintPrimary,
                    pressed: theme.tintPrimary,
                    disabled: theme.lightSecondary,
                };
                const buttonTransparentColor = {
                    active: 'transparent',
                    pressed: 'transparent',
                    disabled: 'transparent',
                };
                const buttonTextColorText = {
                    active: theme.tintPrimary,
                    pressed: theme.tintPrimary,
                    disabled: theme.lightSecondary,
                };
                const buttonTextColorTextBlack = {
                    active: theme.darkNeutral,
                    pressed: theme.darkNeutral,
                    disabled: theme.lightSecondary,
                };
                const buttonTextColorTextWhite = {
                    active: theme.lightPrimary,
                    pressed: theme.lightPrimary,
                    disabled: theme.lightSecondary,
                };
                const buttonTextColorTextDestructive = {
                    active: R.color.uiRedPrimary,
                    pressed: R.color.uiRedPrimary,
                    disabled: theme.lightSecondary,
                };
                const buttonTextOutlineBlack = {
                    active: theme.darkNeutral,
                    pressed: theme.darkNeutral,
                    disabled: theme.lightSecondary,
                };
                const buttonBorderOutlineBlack = {
                    active: R.opacity.opaque(theme.darkNeutral),
                    pressed: R.opacity.opaque(theme.darkNeutral),
                    disabled: R.opacity.opaque(theme.lightSecondary),
                };
                const buttonTextOutlineWhite = {
                    active: theme.lightNeutral,
                    pressed: theme.lightNeutral,
                    disabled: theme.darkSecondary,
                };
                const buttonBorderOutlineWhite = {
                    active: R.opacity.opaque(theme.lightNeutral),
                    pressed: R.opacity.opaque(theme.lightNeutral),
                    disabled: R.opacity.opaque(theme.darkSecondary),
                };
                const buttonBgColorDestructivePrimary = {
                    active: R.color.uiRedPrimary,
                    pressed: R.color.uiRedPrimary,
                    disabled: theme.lightNeutral,
                };
                const buttonTextColorDestructivePrimary = {
                    active: R.color.uiLightPrimary,
                    pressed: R.color.uiLightPrimary,
                    disabled: theme.lightSecondary,
                };
                const buttonBgColorDestructiveSecondary = {
                    active: theme.lightStain,
                    pressed: theme.lightStain,
                    disabled: theme.lightNeutral,
                };
                const buttonTextColorDestructiveSecondary = {
                    active: R.color.uiRedPrimary,
                    pressed: R.color.uiRedPrimary,
                    disabled: theme.lightSecondary,
                };
                const buttonContainerStyle = {
                    paddingVertical: R.spacing.xs,
                    paddingHorizontal: R.spacing.s,
                    borderRadius: R.border.radius.default,
                };
                const buttonTextStyle = Object.assign({ textAlign: 'center' }, R.typography.weightMedium);
                const buttonStyle = {
                    primary: {
                        buttonColors: buttonBgColorPrimary,
                        containerStyle: buttonContainerStyle,
                        textColors: buttonTextColorPrimary,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    mainCta: {
                        buttonColors: buttonBgColorMainCta,
                        containerStyle: buttonContainerStyle,
                        textColors: buttonTextColorMainCta,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    secondary: {
                        buttonColors: buttonBgColorSecondary,
                        containerStyle: buttonContainerStyle,
                        textColors: buttonTextColorSecondary,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    text: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
                        textColors: buttonTextColorText,
                        textStyle: Object.assign({}, buttonTextStyle),
                        borderColors: buttonTransparentColor,
                    },
                    textBlack: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
                        textColors: buttonTextColorTextBlack,
                        textStyle: Object.assign({}, buttonTextStyle),
                        borderColors: buttonTransparentColor,
                    },
                    textWhite: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
                        textColors: buttonTextColorTextWhite,
                        textStyle: Object.assign({}, buttonTextStyle),
                        borderColors: buttonTransparentColor,
                    },
                    textDestructive: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { borderRadius: 0, paddingHorizontal: 0 }),
                        textColors: buttonTextColorTextDestructive,
                        textStyle: Object.assign({}, buttonTextStyle),
                        borderColors: buttonTransparentColor,
                    },
                    outlineBlack: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: R.spacing.xs - 1, paddingHorizontal: R.spacing.s - 1, borderWidth: R.border.width.thick }),
                        textColors: buttonTextOutlineBlack,
                        textStyle: buttonTextStyle,
                        borderColors: buttonBorderOutlineBlack,
                    },
                    outlineWhite: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: R.spacing.xs - 1, paddingHorizontal: R.spacing.s - 1, borderWidth: R.border.width.thick }),
                        textColors: buttonTextOutlineWhite,
                        textStyle: buttonTextStyle,
                        borderColors: buttonBorderOutlineWhite,
                    },
                    destructivePrimary: {
                        buttonColors: buttonBgColorDestructivePrimary,
                        containerStyle: buttonContainerStyle,
                        textColors: buttonTextColorDestructivePrimary,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    destructiveSecondary: {
                        buttonColors: buttonBgColorDestructiveSecondary,
                        containerStyle: buttonContainerStyle,
                        textColors: buttonTextColorDestructiveSecondary,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    circularPrimary: {
                        buttonColors: buttonBgColorPrimary,
                        containerStyle: Object.assign({}, buttonContainerStyle, R.elevation.hover, { borderRadius: circularButtonRadius }),
                        textColors: buttonTextColorPrimary,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    circularMainCta: {
                        buttonColors: buttonBgColorMainCta,
                        containerStyle: Object.assign({}, buttonContainerStyle, R.elevation.hover, { borderRadius: circularButtonRadius }),
                        textColors: buttonTextColorMainCta,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                    circularOutlineBlack: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: R.spacing.xs - 1, paddingHorizontal: R.spacing.s - 1, borderWidth: R.border.width.thick, borderRadius: circularButtonRadius }),
                        textColors: buttonTextOutlineBlack,
                        textStyle: buttonTextStyle,
                        borderColors: buttonBorderOutlineBlack,
                    },
                    circularOutlineWhite: {
                        buttonColors: buttonTransparentColor,
                        containerStyle: Object.assign({}, buttonContainerStyle, { paddingVertical: R.spacing.xs - 1, paddingHorizontal: R.spacing.s - 1, borderWidth: R.border.width.thick, borderRadius: circularButtonRadius }),
                        textColors: buttonTextOutlineWhite,
                        textStyle: buttonTextStyle,
                        borderColors: buttonBorderOutlineWhite,
                    },
                    floating: {
                        buttonColors: {
                            active: theme.lightPrimary,
                            pressed: theme.lightPrimary,
                            disabled: theme.lightNeutral,
                        },
                        containerStyle: Object.assign({}, buttonContainerStyle, R.elevation.hover, { borderRadius: circularButtonRadius }),
                        textColors: buttonTextColorSecondary,
                        textStyle: buttonTextStyle,
                        borderColors: buttonTransparentColor,
                    },
                };
                switch (variant) {
                    case VARIANT.PRIMARY:
                        return buttonStyle.primary;
                    case VARIANT.MAIN_CTA:
                        return buttonStyle.mainCta;
                    case VARIANT.SECONDARY:
                        return buttonStyle.secondary;
                    case VARIANT.TEXT:
                        return buttonStyle.text;
                    case VARIANT.TEXT_BLACK:
                        return buttonStyle.textBlack;
                    case VARIANT.TEXT_WHITE:
                        return buttonStyle.textWhite;
                    case VARIANT.TEXT_DESTRUCTIVE:
                        return buttonStyle.textDestructive;
                    case VARIANT.OUTLINE_BLACK:
                        return buttonStyle.outlineBlack;
                    case VARIANT.OUTLINE_WHITE:
                        return buttonStyle.outlineWhite;
                    case VARIANT.DESTRUCTIVE_PRIMARY:
                        return buttonStyle.destructivePrimary;
                    case VARIANT.DESTRUCTIVE_SECONDARY:
                        return buttonStyle.destructiveSecondary;
                    case VARIANT.CIRCULAR_PRIMARY:
                        return buttonStyle.circularPrimary;
                    case VARIANT.CIRCULAR_MAIN_CTA:
                        return buttonStyle.circularMainCta;
                    case VARIANT.CIRCULAR_OUTLINE_BLACK:
                        return buttonStyle.circularOutlineBlack;
                    case VARIANT.CIRCULAR_OUTLINE_WHITE:
                        return buttonStyle.circularOutlineWhite;
                    case VARIANT.FLOATING:
                        return buttonStyle.floating;
                    default:
                        return buttonStyle.primary;
                }
            };
        }
        render() {
            const themedContainerStyle = this.getContainerStyle();
            return <DRNButton themedContainerStyle={themedContainerStyle} {...this.props}/>;
        }
    };
    return hoistStatics(withTheme(ThemedButtonComponent), DRNButton);
}
